import React from "react";
import Seo from "@/components/Seo";
import ServiceHero from "@/components/marketing/service/ServiceHero";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { Send, Newspaper, ShieldCheck, Compass, Shield, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    icon: ShieldCheck,
    name: "Guaranteed Placements",
    path: "/services/guaranteed-placements",
    desc: "Guaranteed coverage on named publications you choose. Published, indexed, and fully attributed.",
  },
  {
    icon: Send,
    name: "Journalist Outreach",
    path: "/services/journalist-outreach",
    desc: "Real journalists choosing to cover your story. Our in-house PR team handles targeting and pitching.",
  },
  {
    icon: Newspaper,
    name: "Newswire Distribution",
    path: "/services/newswire-distribution",
    desc: "Broad syndication and reach across 1,700+ outlets and 100,000+ journalists worldwide.",
  },
  {
    icon: Compass,
    name: "Find Your Fit",
    path: "/services/find-your-fit",
    desc: "Not sure which service fits? Answer a few questions and we'll recommend the right mix.",
  },
  {
    icon: Shield,
    name: "Reputation Management",
    path: "/services/reputation-management",
    desc: "Own the search results for your name and brand, including Google Knowledge Panel creation.",
  },
];

export default function ServicesOverview() {
  return (
    <div className="bg-canvas">
      <Seo title="Services | Digital24" />
      <ServiceHero
        eyebrow="OUR SERVICES"
        title="Every way Digital24 gets you covered."
        subtitle="From guaranteed placements on named publications to earned journalist outreach, newswire syndication, and reputation management — pick a service or let us tailor the mix."
        primaryCTA={{ label: "Contact Us", to: "/contact" }}
        secondaryCTA={{ label: "View Packages", to: "/packages" }}
      />
      <section className="py-7 sm:py-9 lg:py-12">
        <Container>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s) => (
              <Link key={s.name} to={s.path} className="group bg-white border border-[#e8e6ef] rounded-xl p-8 flex flex-col hover:border-cobalt/40 hover:shadow-sm transition-all">
                <div className="w-11 h-11 rounded-lg bg-cobalt/10 flex items-center justify-center mb-5">
                  <s.icon className="w-5 h-5 text-cobalt" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-bone mb-3">{s.name}</h3>
                <p className="text-sm text-steel leading-relaxed mb-6 flex-1">{s.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-medium text-cobalt">
                  Explore <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}